import React, { useMemo } from "react";
import GenericDialogContent from "../../../../dialog/generic-dialog-content/GenericDialogContent";
import { ViewTabs } from "../../../../tabs";
import { translate } from "../../../../../providers";
import styles from "./AiAgentConfigDialogContent.module.css";
import { ConfigurationTab, HistoryTab, QuickLaunchTab } from "./components";
import { AI_AGENT_CONFIG_TABS } from "../../../../../constants";

const AiAgentConfigDialogContent = ({
	actionOption,
	actionOptions = [],
	actionOptionsTitle = "",
	documentOption,
	documentOptions = [],
	documentOptionsTitle = "",
	element,
	historyHeaderTitleKey = "",
	instructions = "",
	isTemplate = false,
	onChangeActionOption,
	onChangeDocumentOption,
	onChangeDocuments,
	onChangeInstructions,
	onChangeQuickLaunchInstructions,
	onChangeSelectedTab,
	onChangeStage,
	onGetHistory,
	onRollbackAgentResults,
	promptHoverText = "",
	promptModelHelperText = "",
	promptModels,
	promptPlaceholder = "",
	promptTitle = "",
	quickLaunchEnabled = false,
	selectedDocuments = {},
	selectedTab,
	stage,
	totalDocuments = 0,
	quickLaunchSelection = [],
}) => {
	const tabs = useMemo(
		() => [
			quickLaunchEnabled && {
				label: translate("common:component.ai-agent-config.dialog.tab-title.quick-launch"),
				value: AI_AGENT_CONFIG_TABS.QUICK_LAUNCH,
			},
			{
				label: translate("common:btn.configuration"),
				value: AI_AGENT_CONFIG_TABS.CONFIGURATION,
			},
			typeof onGetHistory === "function" && {
				label: translate("common:btn.history"),
				value: AI_AGENT_CONFIG_TABS.HISTORY,
			},
		],
		[onGetHistory, quickLaunchEnabled]
	);
	const tabCount = useMemo(() => tabs.filter((tab) => !!tab?.value).length, [tabs]);
	const handleRenderTab = () => {
		if (selectedTab === AI_AGENT_CONFIG_TABS.HISTORY) {
			return (
				<HistoryTab
					element={element}
					historyHeaderTitleKey={historyHeaderTitleKey}
					onGetHistory={onGetHistory}
					onRollbackAgentResults={onRollbackAgentResults}
				/>
			);
		}
		if (selectedTab === AI_AGENT_CONFIG_TABS.QUICK_LAUNCH) {
			return (
				<QuickLaunchTab
					quickLaunchSelection={quickLaunchSelection}
					onChangeQuickLaunchInstructions={onChangeQuickLaunchInstructions}
				/>
			);
		}
		return (
			<ConfigurationTab
				actionOption={actionOption}
				actionOptions={actionOptions}
				actionOptionsTitle={actionOptionsTitle}
				documentOption={documentOption}
				documentOptions={documentOptions}
				documentOptionsTitle={documentOptionsTitle}
				instructions={instructions}
				isTemplate={isTemplate}
				promptHoverText={promptHoverText}
				promptModelHelperText={promptModelHelperText}
				promptModels={promptModels}
				promptPlaceholder={promptPlaceholder}
				promptTitle={promptTitle}
				selectedDocuments={selectedDocuments}
				stage={stage}
				totalDocuments={totalDocuments}
				onChangeActionOption={onChangeActionOption}
				onChangeDocumentOption={onChangeDocumentOption}
				onChangeDocuments={onChangeDocuments}
				onChangeInstructions={onChangeInstructions}
				onChangeStage={onChangeStage}
			/>
		);
	};
	return (
		<GenericDialogContent className={styles.dialogContent}>
			{tabCount > 1 && (
				<ViewTabs
					noPadding
					noShadow
					className={styles.tabs}
					selectedTab={selectedTab}
					tabIdentifier="value"
					tabs={tabs}
					onChange={onChangeSelectedTab}
				/>
			)}
			{handleRenderTab()}
		</GenericDialogContent>
	);
};

export default AiAgentConfigDialogContent;
